export default __webpack_public_path__ + "static/media/end-youtube.4a7486ea.svg";